import { Component, computed, HostBinding, input } from '@angular/core';
import { ThemeColor } from '../helpers';

@Component({
  selector: 'app-pan-checkbox, [panCheckbox]',
  templateUrl: './pan-checkbox.component.html',
  styleUrl: './pan-checkbox.component.scss',
  standalone: false,
})
export class PanCheckboxComponent {
  public color = input<ThemeColor>('primary');
  public disabled = input<boolean>(false);

  @HostBinding('class')
  public get hostClasses() {
    return this.classes().join(' ');
  }

  @HostBinding('attr.disabled')
  public get isDisabled() {
    return this.disabled() ? true : null;
  }

  public classes = computed(() => {
    return ['checkbox', `checkbox-color-${this.color()}`];
  });
}
